
    import { initNotifications } from "/js/notifications.js";
    initNotifications();
  